
















import Vue, { PropType } from "vue";

/* Interfaces */
import { ISummaryDetails } from "@/interfaces/ISummaryDetails";

export default Vue.extend({
  data: () => ({}),
  props: {
    summaryDetails: {
      type: Array as PropType<ISummaryDetails[]>,
      required: true,
    },
  },
});
